import { useQuery } from '@tanstack/react-query'

import { useQueryClient } from '@tanstack/react-query'

import { QueryKeys } from '../../../../constants/queryKeys.constants'
import { getPricingConfiguration, updatePricingConfiguration } from '../../services/configuration.service'
import { PricingConfigurationType, PricingListType } from '../types/pricingConfiguration.types'
import { ConfigurationCategory } from '../../types/configuration.types'

export const usePricingConfiguration = (enabled = true) => {
  const queryClient = useQueryClient()

  const { data: configuration, isLoading } = useQuery<PricingConfigurationType>({
    queryKey: [QueryKeys.CONFIGURATION, ConfigurationCategory.PRICING],
    queryFn: getPricingConfiguration,
    enabled,
  })

  const update = async (data: Partial<PricingConfigurationType>) => {
    await updatePricingConfiguration(data)
    queryClient.invalidateQueries({ queryKey: [QueryKeys.CONFIGURATION, ConfigurationCategory.PRICING] })
  }

  const lists: PricingListType[] = configuration?.lists ?? []

  return {
    lists,
    isLoading,
    update,
  }
}
